export default "/kiban/_next/static/images/white-76796c7ec733d1769571d8a0889b413c.png";